import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { reportList } from "./reportList";
import { MatTableDataSource } from "@angular/material/table";
import { TruckOwnerService } from "../truck-owner.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { formatDate } from "@angular/common";
import { Router } from "@angular/router";

@Component({
  selector: "app-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.css"],
})
export class ReportsComponent implements OnInit {
  reportsForm: FormGroup;
  token: any;
  displayedColumns: string[] = [
    "Date",
    "WONo",
    "TripId",
    "LRNo",
    "From",
    "To",
    "TruckNo",
    "DDCNo",
    "LoadedQuantity",
    "priceTon",
    "unloadedQuantity",
    "Amount",
    "SalesOrderNo",
    "Tripstatus",
  ];
  reportList: MatTableDataSource<reportList>;

  searchData: boolean = false;
  searchOpen: boolean = true;
  toggleSearch: boolean = false;
  xlDate: any = [];
  example: any = [];
  fromCityDetails: any;
  toCityDetails: any;
  tripDetails: any;
  lrDetails: any;
  vehicleDetails: any;
  vehicalCatDetails: any;
  salesorderDetails: any;
  workOrderDetails: any;
  tripStatusDetails: any;
  vehicleCateg: any;
  minDate = new Date();
  fromLocation: any = -1;
  toLocation: any = -1;
  fromDate: any = -1;
  toDate: any = -1;
  lrNo: any = -1;
  vchlNo: any = -1;
  vehicleCatg: any = -1;
  salesOrderNo: any = -1;
  workOrderNo: any = -1;
  download: any = -1;
  selectedTripData: any = -1;
  tripStatus: any = -1;
  reportsArray: any = [];
  reportsData: any = [];
  ledgerArray: any = [];
  downloadArray: any;
  data: any = [];
  downloadReports = 1;
  reportError: boolean = false;
  loading: boolean = false;
  isSearching: boolean = true;
  isSearchDisabled: boolean = false;
  clear_search: boolean = false;
  @ViewChild("newItem") newItem: ElementRef;

  constructor(
    private services: TruckOwnerService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.reportsForm = this.formBuilder.group({
      from_loc: [""],
      to_loc: [""],
      from_date: [""],
      to_date: [""],
      lr_no: [""],
      sales_order: [""],
      work_order: [""],
      trip_status: [""],
      vehicle_categ: [""],
      vehicle_no: [""],
      trip_id: [""],
    });
    this.reports(
      this.fromDate,
      this.toDate,
      this.fromLocation,
      this.toLocation,
      this.selectedTripData,
      this.lrNo,
      this.vchlNo,
      this.salesOrderNo,
      this.workOrderNo,
      this.tripStatus,
      this.download
    );
    this.getDropDownList();
    let triptype = "reports";
    sessionStorage.setItem("tripType", triptype);
  }

  transformToUppercase(event: any) {
    event.target.value = event.target.value.toUpperCase();
  }

  capitalizeFirstLetter(value: string): string {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  applyFilter() {
    this.download = this.downloadReports;
    if (this.reportsForm.value.from_date) {
      this.reports(
        formatDate(
          new Date(this.reportsForm.value.from_date),
          "yyyy-MM-dd",
          "en-US"
        ) || this.fromDate,
        formatDate(
          new Date(this.reportsForm.value.to_date),
          "yyyy-MM-dd",
          "en-US"
        ) || this.toDate,
        this.reportsForm.value.from_loc || this.fromLocation,
        this.reportsForm.value.to_loc || this.toLocation,
        this.reportsForm.value.trip_id || this.selectedTripData,
        this.reportsForm.value.lr_no || this.lrNo,
        this.reportsForm.value.vehicle_no || this.vchlNo,
        this.reportsForm.value.sales_order || this.salesOrderNo,
        this.reportsForm.value.work_order || this.workOrderNo,
        this.reportsForm.value.trip_status || this.tripStatus,
        this.download
      );
    }
    if (this.reportsForm.value.to_date) {
      this.reports(
        this.reportsForm.value.from_date || this.fromDate,
        this.reportsForm.value.to_date || this.toDate,
        this.reportsForm.value.from_loc || this.fromLocation,
        this.reportsForm.value.to_loc || this.toLocation,
        this.reportsForm.value.trip_id || this.selectedTripData,
        this.reportsForm.value.lr_no || this.lrNo,
        this.reportsForm.value.vehicle_no || this.vchlNo,
        this.reportsForm.value.sales_order || this.salesOrderNo,
        this.reportsForm.value.work_order || this.workOrderNo,
        this.reportsForm.value.trip_status || this.tripStatus,
        this.download
      );
    }
    if (this.reportsForm.value.from_loc) {
      this.reports(
        this.reportsForm.value.from_date || this.fromDate,
        this.reportsForm.value.to_date || this.toDate,
        this.reportsForm.value.from_loc || this.fromLocation,
        this.reportsForm.value.to_loc || this.toLocation,
        this.reportsForm.value.trip_id || this.selectedTripData,
        this.reportsForm.value.lr_no || this.lrNo,
        this.reportsForm.value.vehicle_no || this.vchlNo,
        this.reportsForm.value.sales_order || this.salesOrderNo,
        this.reportsForm.value.work_order || this.workOrderNo,
        this.reportsForm.value.trip_status || this.tripStatus,
        this.download
      );
    }
    if (this.reportsForm.value.to_loc) {
      this.reports(
        this.reportsForm.value.from_date || this.fromDate,
        this.reportsForm.value.to_date || this.toDate,
        this.reportsForm.value.from_loc || this.fromLocation,
        this.reportsForm.value.to_loc || this.toLocation,
        this.reportsForm.value.trip_id || this.selectedTripData,
        this.reportsForm.value.lr_no || this.lrNo,
        this.reportsForm.value.vehicle_no || this.vchlNo,
        this.reportsForm.value.sales_order || this.salesOrderNo,
        this.reportsForm.value.work_order || this.workOrderNo,
        this.reportsForm.value.trip_status || this.tripStatus,
        this.download
      );
    }
    if (this.reportsForm.value.trip_id) {
      this.reports(
        this.reportsForm.value.from_date || this.fromDate,
        this.reportsForm.value.to_date || this.toDate,
        this.reportsForm.value.from_loc || this.fromLocation,
        this.reportsForm.value.to_loc || this.toLocation,
        this.reportsForm.value.trip_id || this.selectedTripData,
        this.reportsForm.value.lr_no || this.lrNo,
        this.reportsForm.value.vehicle_no || this.vchlNo,
        this.reportsForm.value.sales_order || this.salesOrderNo,
        this.reportsForm.value.work_order || this.workOrderNo,
        this.reportsForm.value.trip_status || this.tripStatus,
        this.download
      );
    }
    if (this.reportsForm.value.lr_no) {
      this.reports(
        this.reportsForm.value.from_date || this.fromDate,
        this.reportsForm.value.to_date || this.toDate,
        this.reportsForm.value.from_loc || this.fromLocation,
        this.reportsForm.value.to_loc || this.toLocation,
        this.reportsForm.value.trip_id || this.selectedTripData,
        this.reportsForm.value.lr_no || this.lrNo,
        this.reportsForm.value.vehicle_no || this.vchlNo,
        this.reportsForm.value.sales_order || this.salesOrderNo,
        this.reportsForm.value.work_order || this.workOrderNo,
        this.reportsForm.value.trip_status || this.tripStatus,
        this.download
      );
    }
    if (this.reportsForm.value.vehicle_no) {
      this.reports(
        this.reportsForm.value.from_date || this.fromDate,
        this.reportsForm.value.to_date || this.toDate,
        this.reportsForm.value.from_loc || this.fromLocation,
        this.reportsForm.value.to_loc || this.toLocation,
        this.reportsForm.value.trip_id || this.selectedTripData,
        this.reportsForm.value.lr_no || this.lrNo,
        this.reportsForm.value.vehicle_no || this.vchlNo,
        this.reportsForm.value.sales_order || this.salesOrderNo,
        this.reportsForm.value.work_order || this.workOrderNo,
        this.reportsForm.value.trip_status || this.tripStatus,
        this.download
      );
    }
    if (this.reportsForm.value.sales_order) {
      this.reports(
        this.reportsForm.value.from_date || this.fromDate,
        this.reportsForm.value.to_date || this.toDate,
        this.reportsForm.value.from_loc || this.fromLocation,
        this.reportsForm.value.to_loc || this.toLocation,
        this.reportsForm.value.trip_id || this.selectedTripData,
        this.reportsForm.value.lr_no || this.lrNo,
        this.reportsForm.value.vehicle_no || this.vchlNo,
        this.reportsForm.value.sales_order || this.salesOrderNo,
        this.reportsForm.value.work_order || this.workOrderNo,
        this.reportsForm.value.trip_status || this.tripStatus,
        this.download
      );
    }
    if (this.reportsForm.value.work_order) {
      this.reports(
        this.reportsForm.value.from_date || this.fromDate,
        this.reportsForm.value.to_date || this.toDate,
        this.reportsForm.value.from_loc || this.fromLocation,
        this.reportsForm.value.to_loc || this.toLocation,
        this.reportsForm.value.trip_id || this.selectedTripData,
        this.reportsForm.value.lr_no || this.lrNo,
        this.reportsForm.value.vehicle_no || this.vchlNo,
        this.reportsForm.value.sales_order || this.salesOrderNo,
        this.reportsForm.value.work_order || this.workOrderNo,
        this.reportsForm.value.trip_status || this.tripStatus,
        this.download
      );
    }
    if (this.reportsForm.value.trip_status) {
      this.reports(
        this.reportsForm.value.from_date || this.fromDate,
        this.reportsForm.value.to_date || this.toDate,
        this.reportsForm.value.from_loc || this.fromLocation,
        this.reportsForm.value.to_loc || this.toLocation,
        this.reportsForm.value.trip_id || this.selectedTripData,
        this.reportsForm.value.lr_no || this.lrNo,
        this.reportsForm.value.vehicle_no || this.vchlNo,
        this.reportsForm.value.sales_order || this.salesOrderNo,
        this.reportsForm.value.work_order || this.workOrderNo,
        this.reportsForm.value.trip_status || this.tripStatus,
        this.download
      );
    }
  }

  searchBtn(item: any) {
    if (item != "") {
      this.searchData = true;
      this.isSearching = false;
      this.searchOpen = false;
      this.clear_search = true;
      // this.reportsForm.value.trip_id = "";
      this.reports(
        this.fromDate,
        this.toDate,
        this.fromLocation,
        this.toLocation,
        this.reportsForm.value.trip_id || this.selectedTripData,
        this.lrNo,
        this.vchlNo,
        this.salesOrderNo,
        this.workOrderNo,
        this.tripStatus,
        this.download
      );
    }
  }

  openSearch_btn() {
    this.searchData = true;
    this.searchOpen = false;
    this.isSearching = true;
    this.clear_search = false;
  }

  Search() {
    this.isSearching = true;
    this.clear_search = false;
    // this.download = this.downloadReports;
    this.reports(
      this.reportsForm.value.from_date || this.fromDate,
      this.reportsForm.value.to_date || this.toDate,
      this.reportsForm.value.from_loc || this.fromLocation,
      this.reportsForm.value.to_loc || this.toLocation,
      this.reportsForm.value.trip_id || this.selectedTripData,
      this.reportsForm.value.lr_no || this.lrNo,
      this.reportsForm.value.vehicle_no || this.vchlNo,
      this.reportsForm.value.sales_order || this.salesOrderNo,
      this.reportsForm.value.work_order || this.workOrderNo,
      this.reportsForm.value.trip_status || this.tripStatus,
      this.download
    );
  }

  downloadXl(downloadArray: string) {
    if (downloadArray === "") {
      this.download = this.downloadReports;
      let from = "Download";
      this.reports(
        this.fromDate,
        this.toDate,
        this.fromLocation,
        this.toLocation,
        this.selectedTripData,
        this.lrNo,
        this.vchlNo,
        this.salesOrderNo,
        this.workOrderNo,
        this.tripStatus,
        this.download,
        from
      );
    } else {
      window.open(downloadArray, "_blank");
    }
  }

  reports(
    fromDate: any,
    toDate: any,
    fromLocation: any,
    toLocation: any,
    selectedTripData: any,
    lrNo: any,
    vchlNo: any,
    salesOrderNo: any,
    workOrderNo: any,
    tripStatus: any,
    download: any,
    from?: any
  ) {
    this.loading = true;
    this.services
      .getReportsList(
        this.token,
        fromLocation,
        toLocation,
        fromDate,
        toDate,
        lrNo,
        vchlNo,
        salesOrderNo,
        workOrderNo,
        selectedTripData,
        tripStatus,
        this.download
      )

      .subscribe(
        (response: any) => {
          this.ledgerArray = [];
          this.data = [];
          this.downloadArray = response.body.url;
          if (from === "Download") {
            window.open(this.downloadArray, "_blank");
          }
          this.reportsArray = response.body.data;
          this.reportsArray.forEach((ele: any) => {
            let reportsData = [];
            reportsData.push(
              formatDate(new Date(ele.pickup_date), "yyyy-MM-dd", "en")
            );

            reportsData.push(ele.workorder_id);
            reportsData.push(ele.trip_id);
            reportsData.push(ele.workOrderOtherDetails?.lr_number);
            reportsData.push(ele.pickup_details.from_city_name);
            reportsData.push(ele.dropoff_details.to_city_name);
            reportsData.push(ele.truck_id?.truck_number);
            reportsData.push(ele.workOrderOtherDetails?.ddc_no);
            reportsData.push(ele.workOrderOtherDetails?.loading_point);
            reportsData.push(ele.workOrderOtherDetails?.price_per_ton);
            reportsData.push(ele.workOrderOtherDetails?.unloading_point);
            reportsData.push(
              ele.workOrderOtherDetails?.loading_point *
                ele.workOrderOtherDetails?.price_per_ton ||
                ele.workOrderOtherDetails?.unloading_point *
                  ele.workOrderOtherDetails?.price_per_ton
            );
            reportsData.push(ele.workOrderOtherDetails?.sales_order_number);
            this.data.push(ele);
          });
          this.reportList = new MatTableDataSource(this.reportsArray);

          this.loading = false;
        },
        (error) => {
          this.loading = false;

          if (error.message === "No Records Found") {
            this.reportsArray = [];
            return;
          }

          if (error.status == 404) {
            this.reportsArray = [];
            return;
          }
          if (error.status != 404) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  getDropDownList() {
    this.services.listDropDown(this.token).subscribe((response: any) => {
      this.fromCityDetails = response.body.data.fromCityDetail;
      this.toCityDetails = response.body.data.toCityDetail;
      this.tripDetails = response.body.data.tripNumbers;
      this.lrDetails = response.body.data.lr_Numbers;
      this.vehicleDetails = response.body.data.truck_data;
      this.vehicalCatDetails = response.body.data.truck_catgory_name;
      this.salesorderDetails = response.body.data.sls_order_Nos;
      this.workOrderDetails = response.body.data.workOrder_data;
      this.tripStatusDetails = response.body.data.trip_status;
      this.vehicleCateg = response.body.data.truck_catgory_dtl;
    });
  }

  reset() {
    this.reportsForm.reset();
    this.searchData = !this.searchData;
    this.toggleSearch = !this.toggleSearch;
    this.searchOpen = !this.searchOpen;
    this.reports(
      this.fromDate,
      this.toDate,
      this.fromLocation,
      this.toLocation,
      this.selectedTripData,
      this.lrNo,
      this.vchlNo,
      this.salesOrderNo,
      this.workOrderNo,
      this.tripStatus,
      this.download
    );
  }
  clearSearch() {
    this.isSearching = true;
    this.clear_search = false;
    this.searchOpen = true;
    this.searchData = false;
    this.reportsForm.reset();
    this.newItem.nativeElement.value = "";
    this.reports(
      this.fromDate,
      this.toDate,
      this.fromLocation,
      this.toLocation,
      this.selectedTripData,
      this.lrNo,
      this.vchlNo,
      this.salesOrderNo,
      this.workOrderNo,
      this.tripStatus,
      this.download
    );
  }
}
